import React from 'react'

const Loading = () => {
    return (
        <div className='d-flex align-items-center justify-content-center' style={{ height: "75vh" }}>
            <div className="card p-4 shadow cool-loading-card d-flex align-items-center">
                <div className="shimmer avatar mb-4"></div>

                {/* Centered "Loading..." text inside card */}
                <div className="text-center mb-4">
                    <span className="text-muted fw-semibold loading-text">Loading...</span>
                </div>

                <div className="shimmer line mb-2" style={{ width: '90%' }}></div>
                <div className="shimmer line mb-2" style={{ width: '70%' }}></div>
            </div>
        </div>
    )
}

export default Loading
